import DataService from './data-service';

export default class API extends DataService {
  constructor(options) {
    super({
      authStoreKey: options.authStoreKey,
      baseUrl: '/stage-ajax',
      requestParams: {
        'stage-language': document.documentElement.lang || 'fi'
      }
    });
  }

  /**
   * Get blog articles from API
   * @param {object} params required
   * @param {number} params.limit limit result (required)
   * @return {array}
   */
  getBlogArticles(params) {
    return super.get('/blog', params);
  }

}
